export const normalizeWithSeparator = (val: string = '') => {
  const numberOnly = val?.replace(/[^0-9]/g, '');
  return numberOnly?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
